import React from 'react';
import { withNamespaces } from 'react-i18next';
import './RiskDisclosure.scss';

const RiskDisclosure = ({ t }) => {
  return (
    <div className="risk-disclosure">
      <div
        className="risk-disclosure__content"
        dangerouslySetInnerHTML={{ __html: t('components.RiskDisclosure.content') }}
      />
    </div>
  );
};

export default withNamespaces('core')(RiskDisclosure);



// WEBPACK FOOTER //
// ../src/components/Footer/RiskDisclosure.jsx